import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
} from "recharts";
import { CustomLegend } from "./custom-legend";
import { CustomTooltip } from "./custom-tooltip";
import { ChartWrapper } from "./chart-wrapper";
import type { FC } from "react";
import { useChartTheme } from "./hooks/useChartTheme";

export type OrganizationStatus =
  | "NEW"
  | "ONBOARDING"
  | "GESTATING"
  | "LIVE"
  | "DEAD"
  | "TEST";

interface MonthlyTrend {
  readonly month: string;
  [key: string]: number | string;
}

/**
 * Displays organization status trends over time using a stacked bar chart
 */
export const StatusTrendsChart: FC<{ data: readonly MonthlyTrend[] }> = ({
  data,
}) => {
  const { statusColors, chartProps } = useChartTheme();
  const statusKeys = Object.keys(statusColors) as OrganizationStatus[];

  return (
    <ChartWrapper>
      <BarChart data={[...data]}>
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis dataKey="month" />
        <YAxis />
        <Tooltip
          content={<CustomTooltip />}
          {...chartProps.tooltip}
          cursor={false}
        />
        <Legend content={<CustomLegend />} {...chartProps.legend} />
        {statusKeys.map((status) => (
          <Bar
            key={status}
            dataKey={status}
            stackId="status"
            fill={statusColors[status]}
            name={status}
          />
        ))}
      </BarChart>
    </ChartWrapper>
  );
};
